export const TOGGLE_NAV_MENU = "TOGGLE_NAV_MENU";
export const SET_RESOURCES = "SET_RESOURCES";
